<template>
  <v-dialog eager v-model="dialog" max-width="280">
    <v-card>
      <v-card-title class="primary white--text"
        >Link di invito
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <div class="pa-5">
        Copia il link qui sotto e <b>condividilo con gli amici</b> che vuoi far
        partecipare a quest'asta
      </div>
      <div class="px-5 pb-5">
        <div class="link-invito">{{ urlInvito }}</div>
      </div>
      <div class="px-5 pb-5 text-center">
        <!-- <v-btn
          depressed
          rounded
          class="orange white--text"
          v-clipboard:copy="urlInvitoComputed"
          v-clipboard:success="onCopySuccess"
        >
          COPIA LINK DI INVITO
        </v-btn> -->
        <v-btn
          depressed
          rounded
          class="orange white--text"
          @click="copyToClipboard"
        >
          COPIA LINK DI INVITO
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import db from "../../js/db";
import toast from "../../js/toast";

export default {
  name: "dialog-invito",
  mixins: [mixins, toast],
  mounted() {
    console.log("--> DialogInvito mounted.");
    db.on("invitoEmitted", this.handleInvitoEmitted);
  },
  destroyed() {
    console.log("<-- DialogInvito destroyed.");
    db.off("invitoEmitted", this.handleInvitoEmitted);
  },
  data() {
    return {
      urlInvito: "",
      dialog: false,
    };
  },
  // computed: {
  //   urlInvitoComputed() {
  //     console.log("urlInvitoComputed", this.urlInvito);
  //     return this.urlInvito;
  //   },
  // },
  methods: {
    handleInvitoEmitted() {
      this.show();
    },
    async show() {
      this.dialog = true;
      const pass = await db.getAstaPass(this.asta_id);
      const resolvedPath = this.$router.resolve({
        name: "invito",
        params: { pass: pass },
      }).href;
      let urlInvito = window.location.host + "/" + resolvedPath;
      this.urlInvito = urlInvito;
    },
    // onCopySuccess() {
    //   this.successToast("Link di invito copiato!", "");
    // },
    copyToClipboard() {
      const textToCopy = this.urlInvito;
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.successToast("Link di invito copiato!", "");
        })
        .catch((error) => {
          console.error("Error copying to clipboard:", error);
          this.errorToast("Non è stato possibile copiare il link. Copialo manualmente", "");
        });
    },
  
    dismiss() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.link-invito {
  border: 1px solid #CFD8DC;
    padding: 5px;
    border-radius: 4px
}
</style>
